/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Damie — abre mini-cart drawer após "Comprar" no configurador 3D — main
document.addEventListener('damie:cart:open', function () {
  var drawer = document.getElementById('mini-cart')
  if (drawer) drawer.open = true
});

// Linha 1.0: resumo e painéis de configuração no celular, como na linha 2.0.
(function () {
  function initMobileSummary() {
    document.querySelectorAll('.damie-linha-1').forEach(function (root) {
      if (root.dataset.mobileSummary) return;
      var ui = root.querySelector('.tc-mob-ui');
      var tabs = root.querySelector('[data-dc-mob-tabs]');
      var panels = root.querySelector('[data-dc-mob-panels]');
      if (!ui || !tabs || !panels || !tabs.children.length) return;
      root.dataset.mobileSummary = 'true';
      var mobile = window.matchMedia('(max-width:749px)');
      var summary = document.createElement('div');
      summary.className = 'damie-1-mobile-summary';
      var head = document.createElement('div');
      head.className = 'damie-1-mobile-sheet-head';
      var title = document.createElement('h3');
      title.tabIndex = -1;
      var close = document.createElement('button');
      close.type = 'button';
      close.textContent = '×';
      close.setAttribute('aria-label', 'Fechar opções');
      head.append(title, close);
      var done = document.createElement('button');
      done.type = 'button';
      done.className = 'damie-1-mobile-done';
      done.textContent = 'Concluir';
      var mechanismLabel = ui.querySelector('[data-dc-mob-mechanism]');
      if (mechanismLabel) mechanismLabel.after(summary);
      else ui.prepend(summary);
      panels.before(head);
      panels.after(done);
      var lastTrigger;
      function dismiss() {
        root.classList.remove('damie-1-sheet-open');
        summary.querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
        if (mobile.matches && lastTrigger) lastTrigger.focus({ preventScroll: true });
      }
      function open(tab) {
        if (!mobile.matches) return;
        var id = tab.getAttribute('data-mob-block-id');
        var panel = Array.from(panels.children).find(function (item) { return item.getAttribute('data-mob-block-id') === id; });
        if (!panel) return;
        title.textContent = tab.textContent.replace(/^\s*\d+\s*/, '').trim();
        root.classList.add('damie-1-sheet-open');
        summary.querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-expanded', String(button.dataset.blockId === id)); });
        title.focus({ preventScroll: true });
      }
      Array.from(tabs.children).forEach(function (tab) {
        var id = tab.getAttribute('data-mob-block-id');
        var panel = Array.from(panels.children).find(function (item) { return item.getAttribute('data-mob-block-id') === id; });
        if (!panel) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.blockId = id;
        button.dataset.type = panel.getAttribute('data-step-type');
        panel.id = root.id + '-mobile-' + id;
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = '<span class="damie-1-summary-thumb" aria-hidden="true"></span><span class="damie-1-summary-text"><span class="damie-1-summary-label"></span><span class="damie-1-summary-value"></span></span><span class="damie-1-summary-link"></span>';
        button.querySelector('.damie-1-summary-label').textContent = tab.textContent.replace(/^\s*\d+\s*/, '').trim();
        button.querySelector('.damie-1-summary-link').textContent = button.dataset.type === 'opcionais' ? 'escolher acessórios >' : 'alterar revestimento >';
        button.addEventListener('click', function () { lastTrigger = button; tab.click(); });
        summary.append(button);
        tab.addEventListener('click', function () { open(tab); });
      });
      close.addEventListener('click', dismiss);
      done.addEventListener('click', dismiss);
      ui.addEventListener('keydown', function (event) { if (event.key === 'Escape' && root.classList.contains('damie-1-sheet-open')) dismiss(); });
      mobile.addEventListener('change', dismiss);
      function sync() {
        summary.querySelectorAll('button').forEach(function (button) {
          var value = button.querySelector('.damie-1-summary-value');
          var thumb = button.querySelector('.damie-1-summary-thumb');
          if (button.dataset.type === 'opcionais') {
            var count = root.querySelectorAll('[data-dc-panels] [data-step-type="opcionais"] .tc-item-card.active').length;
            value.textContent = count ? count + (count === 1 ? ' selecionado' : ' selecionados') : 'Nenhum selecionado';
            thumb.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/></svg>';
          } else {
            var material = root.querySelector('[data-dc-panels] [data-step-type="revestimento"] .tc-item-card.active .tc-ic-title');
            var color = root.querySelector('[data-dc-panels] .tc-swatch.active .tc-swatch-name');
            value.textContent = (material ? material.textContent.trim() : '') + (color ? ' · ' + color.textContent.trim() : '');
            var swatch = root.querySelector('[data-dc-panels] .tc-swatch.active .tc-swatch-dot');
            if (swatch) thumb.style.background = getComputedStyle(swatch).background;
          }
        });
      }
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; sync(); });
      }).observe(panels, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobileSummary);
  else initMobileSummary();
  document.addEventListener('shopify:section:load', initMobileSummary);
})();
